module.exports = __webpack_public_path__ + "img/packageCurrent.2cdb9ab6.svg";